import { UAParser } from 'ua-parser-js'

const uaParser = new UAParser()

// OS名の取得
export const getOs = () => {
  return uaParser.getResult().os.name
}

// ブラウザ名の取得
export const getBrowser = () => {
  return uaParser.getResult().browser.name
}

// ブラウザバージョンの取得（number）
export const getBrowserVersion = () => {
  return uaParser.getResult().browser.version
}

// ブラウザのメジャーバージョンの取得（string）
export const getBrowserMejorVersion = () => {
  return uaParser.getResult().browser.major
}

// デバイスの取得
export const getDevice = () => {
  return uaParser.getDevice()
}

const checkOs = (os) => {
  switch (os) {
    case 'Mac OS':
    case 'Windows':
    case 'iOS':
    case 'Android':
    case 'Chromium OS':
    case 'Debian':
    case 'Linux':
    case 'Fedora':
    case 'Slackware':
    case 'Ubuntu':
      return true
    default:
      return false
  }
}

const checkBrowser = (browser, version, majorVersion, os) => {
  let v = 0

  switch (browser) {
    case 'Chrome':
      // iOSのChromeは利用不可
      if (os === 'iOS') return false

      // Chromeでバージョン58以上なら
      v = Number(version.split('.')[0])

      return v >= 58
    case 'Firefox':
      // iOS・AndroidのFirefoxは利用不可
      if (os === 'iOS' || os === 'Android') return false

      // Firefoxでバージョン56以上なら
      v = Number(version.split('.')[0])
      return v >= 56
    case 'Safari':
    case 'Mobile Safari':
      // Safariでバージョン12.1以上なら
      v = Number(majorVersion + '.' + version.split('.')[1])
      return v >= 12.1
    case 'Edge':
      // iOS・AndroidのEdgeは利用不可
      if (os === 'iOS' || os === 'Android') return false

      // Edgeでバージョン80以上なら
      v = majorVersion
      return v >= 80
    default:
      return false
  }
}

export const checkAppSupport = () => {
  const uaOs = getOs()

  // ひとまずOSの段階でふるいにかける
  const supportOs = checkOs(uaOs)

  if (supportOs === false) {
    return false
  }

  // ブラウザ・バージョンでふるいにかける
  const browser = getBrowser()
  const browserVersion = getBrowserVersion()
  const browserMajorVersion = Number(getBrowserMejorVersion())

  const supportBrowser = checkBrowser(browser, browserVersion, browserMajorVersion, uaOs)

  return supportBrowser
}
